import script from "./new.vue?vue&type=script&lang=ts&setup=true"
export * from "./new.vue?vue&type=script&lang=ts&setup=true"

import "./new.vue?vue&type=style&index=0&id=1c833612&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c833612"]])

export default __exports__